import React from 'react'
import { Button, Modal } from 'semantic-ui-react'

const Alert = ({
  title,
  content,
  onClose,
  closeOnDimmerClick = true,
  closeOnEscape = true,
  showCloseIcon = true,
}) => (
  <Modal
    closeIcon={showCloseIcon}
    closeOnDimmerClick={closeOnDimmerClick}
    closeOnEscape={closeOnEscape}
    open
    onClose={onClose}
  >
    <Modal.Header>{title}</Modal.Header>
    <Modal.Content>{content}</Modal.Content>
    <Modal.Actions>
      <Button positive onClick={onClose}>
        Got it!
      </Button>
    </Modal.Actions>
  </Modal>
)

export default Alert
